import { useEffect, useState } from 'react';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

import { fastTrackData } from 'helpers/FastTrack/fastTrackData';
import { parseFastTrackQuestions } from 'helpers/FastTrack/parseFastTrackQuestions';

import type { FastTrackQuestion, UseFastTrackInitResult } from 'views/FastTrackContentView/types';

export function useFastTrackQuestions(): UseFastTrackInitResult {
  const [pages, setPages] = useState<FastTrackQuestion[]>([]);
  const [ready, setReady] = useState(false);
  const [appId, setAppId] = useState(-1);
  const [user, setUser] = useState('');

  useEffect(() => {
    const init = async () => {
      const id = (await DataHandler.matchAppId()) as number;
      setAppId(id);

      const userData = ((await StorageHandler.load(storageKeys.user)) as { email?: string } | null) ?? {};
      setUser(userData.email ?? '');

      const appInfo = (await StorageHandler.load(storageKeys.appInfo)) as { fastTrackAppId?: number } | null;
      const fastTrackAppId = appInfo?.fastTrackAppId;

      if (fastTrackAppId) {
        const fetchedPages = (await APIHandler.getAppQuestions(fastTrackAppId)) as FastTrackQuestion[];
        const parsedPages = parseFastTrackQuestions(fetchedPages);
        fastTrackData('totalQuestions', parsedPages.length);
        if (!fastTrackData('startTime')) {
          fastTrackData('startTime', Date.now());
        }
        setPages(parsedPages);
        setReady(true);
      }
    };

    void init();
  }, []);

  return { pages, ready, appId, user };
}
